<ng-container
  *ngFor="let scoringSection of scoringSections; index as scoringSectionIndex"
>
  <div
    class="report-analysis__sectionDetails"
    [id]="'analysis' + scoringSection['scoringSectionName']"
  >
    <div class="report-analysis__sectionDetails__header">
      <span class="report-analysis__sectionDetails__header__sectionName">{{
        scoringSection["scoringSectionName"]
      }}</span>
      <span class="report-analysis__sectionDetails__header__analysis"
        >Analysis</span
      >
    </div>
    <div
      class="report-analysis__sectionDetails__topic report-analysis__sectionDetails__topic__mainHeader"
      [ngClass]="{
        'report-analysis__sectionDetails__topic__mainHeader__math':
          scoringSection['scoringSectionName'] === 'Math',
        'report-analysis__sectionDetails__topic__digital': isDigital
      }"
    >
      <span class="report-analysis__sectionDetails__topic__firstElement"
        >Topic/Subtopic</span
      >
      <span><mat-icon>check</mat-icon></span>
      <span>Total</span>
      <span>%</span>
      <ng-container *ngIf="!isDigital; else digitalLablesBlock">
        <span>Skipped</span>
        <span>Incorrect</span>
      </ng-container>
      <ng-template #digitalLablesBlock>
        <span>Key Concepts</span>
      </ng-template>
      <!-- <span class="report-analysis__sectionDetails__topic__lastElement"></span> -->
    </div>
    <ng-container
      *ngFor="let topic of scoringSection['topics']; index as topicIndex"
    >
      <div
        class="report-analysis__sectionDetails__topic report-analysis__sectionDetails__topic__subHeader"
        [ngClass]="{
          'report-analysis__sectionDetails__topic__digital': isDigital
        }"
      >
        <span class="report-analysis__sectionDetails__topic__firstElement">{{
          topic["topicName"]
        }}</span>
        <span>{{ topic["totalCorrect"] }}</span>
        <span>{{ topic["totalQuestions"] }}</span>
        <span
          >{{
            calculatePercentage(topic["totalCorrect"], topic["totalQuestions"])
          }}%</span
        >
      </div>
      <ng-container
        *ngFor="let subTopic of topic['subTopics']; index as subTopicIndex"
      >
        <div
          class="report-analysis__sectionDetails__topic"
          [ngClass]="{
            'report-analysis__sectionDetails__topic__digital': isDigital
          }"
        >
          <span
            class="report-analysis__sectionDetails__topic__firstElement"
            [ngClass]="{ 'report-analysis__link': isDigital && role === '3' }"
            (click)="
              isDigital && role === '3'
                ? goToLearningModule(scoringSection.tst_id, subTopic.subTopicId)
                : false
            "
            >{{ subTopic["subTopicName"] }}</span
          >
          <span>{{ subTopic["correct"] }}</span>
          <span>{{ subTopic["total"] }}</span>
          <span
            >{{
              calculatePercentage(subTopic["correct"], subTopic["total"])
            }}%</span
          >
          <ng-container *ngIf="!isDigital; else digitalContentBlock">
            <span>{{ subTopic["missedQuestions"] }}</span>
            <span>{{ subTopic["wrongQuestions"] }}</span>
          </ng-container>
          <ng-template #digitalContentBlock>
            <span
              [ngClass]="{ 'report-analysis__link': role === '3' }"
              (click)="
                role === '3'
                  ? goToLearningModule(
                      scoringSection.tst_id,
                      subTopic.subTopicId
                    )
                  : false
              "
            >
              <span
                class="report-analysis__sectionDetails__topic__tags"
                *ngFor="let tag of subTopic['tags']"
              >
                {{ tag }}
              </span>
            </span>
          </ng-template>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
